// extracted by mini-css-extract-plugin
module.exports = {"icon":"PaymentMethodSelector_icon__3kyax"};